


window.addEventListener("DOMContentLoaded",()=>{
	document.querySelectorAll("*[data-htmlcopy]").forEach(x=>{
		document.querySelectorAll(x.dataset.htmlcopy).forEach(t=>{
			x.innerHTML += t.innerHTML;
		});
	});

	document.querySelectorAll(".aj-headerMenu.isOpen").forEach(x=>{
		x.addEventListener("click",()=>{
			document.querySelector('.aj-mobileNav').classList.add("isActive");
		});
	});
	document.querySelectorAll(".aj-headerMenu.isClose").forEach(x=>{
		x.addEventListener("click",()=>{
			document.querySelector('.aj-mobileNav').classList.remove("isActive");
		});
	});

	overflowHandler();
});

window.addEventListener("sliderLoaded",()=>{
	document.querySelectorAll(".am-productListSlider.splide").forEach(x=>{
		let slider = new Splide(x,{
			type:"loop",
			arrows:true,
			pagination:true,
			autoWidth:true,
			breakpoints:{
				768:{
					perPage:1,
					autoWidth:false,
					focus:"center",
					//gap:"3.5725vw",
					//padding:"7.145vw",
					gap:"7.145vw",
					padding:"14.29vw",
				},
			},
		});
		slider.mount();
	});
});

window.addEventListener("customScrollBarLoaded",()=>{
	document.querySelectorAll(".am-headerMenuDrawerCards").forEach(x=>{
		CustomScrollBar.set(x);
	});
});




var headerElement = null;
window.addEventListener("DOMContentLoaded",headerHandler);
window.addEventListener("resize",headerHandler);
window.addEventListener("scroll",headerHandler);
window.addEventListener("click",headerHandler);
function headerHandler(){
	let y = typeof window.scrollY!=='undefined' ? window.scrollY : (typeof document.documentElement.scrollTop!=="undefined" ? document.documentElement.scrollTop  : document.body.scrollTop);
	if(headerElement===null){headerElement=document.querySelector(".am-header");}
	if(typeof(headerElement.headerHandlerPreviousScroll)==="undefined"){headerElement.headerHandlerPreviousScroll=y;}
	if(typeof(headerElement.headerHandlerPreviousDisplay)==="undefined"){headerElement.headerHandlerPreviousDisplay=false;}
	let isHide = false;
	if(y>headerElement.headerHandlerPreviousScroll){isHide=true}
	if(y<=0){isHide=false;}
	headerElement.classList.toggle("hide",isHide);
	headerElement.headerHandlerPreviousScroll = y;
}



var overflowTargets = null;
window.addEventListener("DOMContentLoaded",overflowHandler);
window.addEventListener("resize",overflowHandler);
window.addEventListener("scroll",overflowHandler);
function overflowHandler(){
	if(overflowTargets===null){overflowTargets=document.querySelectorAll("[data-overflowcheck]");}
	overflowTargets.forEach(x=>{
		x.classList.toggle("overflow",x.scrollHeight>x.clientHeight || x.scrollWidth>x.clientWidth);
	});
}





var parallaxTargets = null;
window.addEventListener("load",()=>{
	parallaxTargets = document.querySelectorAll("img[data-parallax]");
	if(parallaxTargets){
		parallaxTargets.forEach(p=>{p.style.objectFit="cover";});
		window.addEventListener("resize",parallaxHandler,{passive:true});
		window.addEventListener("scroll",parallaxHandler,{passive:true});
		parallaxHandler();
	}
});
function parallaxHandler(){
	parallaxTargets.forEach(p=>{
		let r = p.getBoundingClientRect();
		p.style.objectPosition = "center "+((r.top+r.height) / (window.innerHeight+r.height) * 100)+"%";
	});
}
















